<template>
    <div class="search">
        <div class="w-1200">
            <div class="serch">
                <!--下拉框区域-->
                <div class="dropdown">
                    <div class="xiala">
                        <span>{{searchActive}}</span>
                        <img src="../assets/search/dow.png" alt=""/>
                        <dl class="dropdown_menu">
                            <b class="top"><i class="top-arrow1"></i><i class="top-arrow2"></i></b>
                            <dd @click="selectMenu($event)" data-num='1'>摄影图片</dd>
                            <dd @click="selectMenu($event)" data-num='2'>矢量图片</dd>
                            <!--<dd @click="selectMenu($event)" data-num='0'>优质视频</dd>-->
                        </dl>
                    </div>
                </div>
                <!--搜索框-->
                <div class="inpt">
                    <!--<img src="../assets/search/xj.png" alt=""/>-->
                    <input type="text" v-model="keyword" placeholder="  搜索照片、矢量图和视频，多个词注意用空格分隔" @keyup.enter="goSearch"/>
                    <img v-if="searchActive !== '优质视频'" src="../assets/search/photo_camera.png" alt="" class="camera-btn" @click="showUplaodBox" />
                </div>
                <!--搜索图标-->
                <div class="icon-scrch">
                    <img src="../assets/search/ss1.png" alt="" @click="goSearch"/>
                </div>

                <div v-if="uploadBoxShowed" v-loading="reverseSearching" element-loading-text="图片分析中..." element-loading-spinner="el-icon-loading" class="upload-box">
                    <el-upload
                        ref="reverseSearch"
                        drag
                        action=""
                        :auto-upload="false"
                        :on-change="handlePreview"
                        :http-request="reverseSearch"
                        :show-file-list="false"
                    >
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">拖动图片到这里 或者 <em>点击进行上传</em></div>
                    </el-upload>
                    <div v-if="previewImg" class="search-btn">
                        <div class="search-txt">
                            <img :src="previewImg" height="80">
                            <span>{{ previewImgTitle }}</span>
                        </div>
                        <div>
                            <el-button @click="doReverseSearch">开始搜索</el-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import {getCookie} from "../util/common";

    export default {
        name: 'search',
        data() {
            return {
                keyword:'',
                searchActive:'摄影图片',
                dataNum:1,
                showDropdownMenu:false,
                uploadBoxShowed: false,
                reverseSearching: false,
                previewImg: '',
                previewImgTitle: '',
                user_name:'',
                user_id:'',
                register_time:'',
                name:'',
                email:'',
                contact_person:'',
            }
        },
        mounted() {
        },
        created() {
            this.$get('/me')
                .then( res => {
                    if(res.code == 200){
                        this.user_name = res.data.user.user_name
                        this.user_id = res.data.user.id
                        this.register_time = res.data.user.created_at
                        this.name = res.data.user.name
                        this.email = res.data.user.email
                        this.contact_person = res.data.user.contact_person
                    }
                }).catch(error => {
                console.log(error)
            })
        },
        methods: {
            selectMenu(e){
                this.searchActive = e.target.innerText
                this.dataNum = e.target.getAttribute('data-num')
                this.showDropdownMenu = false
            },
            goSearch(){
                let token = getCookie('token')
                if(!token) {
                    this.$router.push('/login')
                    return;
                }
                if(this.keyword && this.user_id){
                    let data2 = {
                        keywords:this.keyword,
                        user_name:this.user_name,
                        user_id:this.user_id,
                        register_time:this.register_time,
                        name:this.name,
                        email:this.email,
                        contact_person:this.contact_person,
                    }
                    this.$post('/es/keywords',data2)
                        .then( res => {
                        }).catch(errors => {
                        console.log(errors);
                    })
                }
                this.type = this.$route.query.mediaType
                if(this.keyword){
                    let data = {
                        keywords:this.keyword,
                        user_id:this.user_id,
                        type:this.type,
                        page_type:1,
                        current_page:1
                    }
                    this.$post('/es/touchDetail',data)
                        .then( res => {
                        }).catch(errors => {
                        console.log(errors);
                    })
                }
                if(this.dataNum){
                    this.$router.push({name:'Search',query:{keyword:this.keyword,mediaType:this.dataNum}})
                }else{
                    this.$router.push({name:'VideoList',query:{keyword:this.keyword}})
                }
            },
            showUplaodBox() {
                this.uploadBoxShowed = !this.uploadBoxShowed
            },
            handlePreview(file, fileList) {
                console.log(file, fileList);
                const isJPG = file.raw.type === 'image/jpeg' || file.raw.type === 'image/png';
                const isLt5M = file.size / 1024 / 1024 < 5;

                if (!isJPG) {
                    this.$message.error('图片必须是JPG或PNG格式!');
                    return;
                }
                if (!isLt5M) {
                    this.$message.error('图片必须小于5MB!');
                    return;
                }
                const _URL = window.URL || window.webkitURL
                this.previewImg = _URL.createObjectURL(file.raw)
                this.previewImgTitle = file.name
            },
            reverseSearch(file) {
                this.reverseSearching = true
                const formData = new FormData()
                formData.append('image', file.file)
                this.$postByFormData('/image/reverse_search', formData).then(res => {
                    this.reverseSearching = false
                    if (res.data.result) {
                        this.$router.push({name:'ReverseSearch',query:{fid:res.data.result,mediaType:this.dataNum}})
                    } else {
                        this.$message({
                            message: '请换张图片',
                            type: 'error'
                        });
                    }
                })
            },
            doReverseSearch() {
                let token = getCookie('token')
                if(!token) {
                    this.$router.push('/login')
                    return;
                }
                this.$refs['reverseSearch'].submit();
            }
        }
    }
</script>


<style scoped>
    * {  padding: 0; margin: 0; box-sizing: border-box; }
    .w-1200{width: 1200px;margin: 0 auto;}
    .xiala{font-size: 16px;}
    .xiala:hover > .dropdown_menu{display: block}
    .serch{background: #f7f7f7;display: flex;justify-content: space-between;height: 50px;border-bottom: 2px solid #1F1F1F;position: relative;}
    .serch-btn{width: 70px;height: 36px;text-align: center;background: #FF9F00;border-radius: 18px;margin: 0 10px;display: inline-block;cursor: pointer;}
    .serch-btn img{width:20px;height: 22px;margin-top: 8px; }
    .dropdown{width: 140px;text-align: center;line-height: 48px;cursor: pointer;}
    .dropdown {position: relative;}
    .dropdown_menu {background: #f7f7f7;position: absolute;top:48px;right: 30px;z-index: 1000;display: none;width: 110px;padding:10px 0;text-align: center;border-top: 1px solid #ddd;}
    .dropdown_menu dd{line-height: 34px!important;font-size:14px;}
    .dropdown_menu dd:hover{background: #e0e0e0;}
    .dropdown dl dd a {color: #333;line-height: 34px;font-size:14px;}
    .inpt{width: 950px;padding-right: 10px;position: relative;}
    input{border: none;height: 48px;line-height: 48px;width: 100%;/*padding-left:40px;*/outline:none;background: #f7f7f7;}
    input::-webkit-input-placeholder {color:#999999;  }
    input:-moz-placeholder {color:#999999;  }
    input::-moz-placeholder {color:#999999;  }
    input:-ms-input-placeholder {color:#999999;  }
    .icon-scrch{width: 110px;text-align: center;cursor: pointer;}
    .icon-scrch img{margin-top: 13px;cursor: pointer;}
    .inpt img{margin-top: 12px;position: absolute;}
    .top-arrow1,.top-arrow2 {width:0;height:0;display:block;position:absolute;left:30px;top:-17px;z-index:5; /*����ie8-*/ border-top:8px transparent dashed;border-left:6px transparent dashed;border-right:6px transparent dashed;border-bottom:8px white solid;overflow:hidden;}
    .top-arrow1 {border-bottom:9px #ddd solid;}
    .top-arrow2 {top:-15px;border-bottom:9px #fff solid;}
    .camera-btn {
        position: absolute;
        top: -3px;
        right: 0;
        cursor: pointer;
        width: 36px;
        height: 36px;
    }
    .upload-box {
        position: absolute;
        top: 45px;
        right: 0;
        width: 500px;
        background: white;
        z-index: 999;
    }
    .upload-box .search-btn {
        padding: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .upload-box .search-btn .search-txt {
        display: flex;
        align-items: center;
    }
    .upload-box .search-btn .search-txt span {
        margin: 0 8px;
        word-break: break-all;
    }
    .upload-box .search-btn .el-button {
        background: #FF9F00;
        color: white;
        border: 0;
        padding: 12px 20px;
    }
</style>
<style>
.serch .el-upload-dragger {
    width: 500px !important;
    border-radius: 0 !important;
}
.serch .el-upload:focus .el-upload-dragger{border-color:#2e2e2e}
.serch .el-upload-dragger:hover {
    border: 1px dashed #2e2e2e;
}
.serch .el-upload-dragger .el-upload__text em {
    color: #2e2e2e;
    font-weight: bold;
    font-size: 16px;
}
.upload-box .el-loading-spinner i {
    color: #FF9F00;
}
.upload-box .el-loading-spinner .el-loading-text {
    color: #FF9F00;
}
</style>
